<template>
    <div class="p-4 flex flex-col xl:flex-row space-y-4 xl:space-y-0 xl:space-x-4">
        <div class="flex-1">
            <h2 v-text="title" class="flex-1 text-sm font-medium text-gray-900"></h2>
            <p v-if="subtitle" v-text="subtitleAsLine" class="mt-1 text-sm text-gray-500"></p>
            <slot></slot>
        </div>
        <div class="flex-shrink-0 flex space-x-4 items-start" v-if="canEdit || canDelete">
            <ui-button-new v-if="canEdit" small @click="$emit('edit')">edit</ui-button-new>
            <ui-button-new v-if="canDelete" small danger @click="$emit('delete')">delete</ui-button-new>
        </div>
    </div>
</template>

<script>
import { toLine } from '@utils'

export default {
    props: {
        title: String,
        subtitle: String|Array,
    },
    computed: {
        subtitleAsLine () {
            return toLine(this.subtitle)
        },
        canEdit () {
            return !! this.$listeners.edit
        },
        canDelete () {
            return !! this.$listeners.delete
        },
    }
}
</script>
